<template>
  <div id="footer" class="">
    <footer class="ic-footer">
        <section class="wrapper">
            <div class="content d-flex flex-column align-items-center">
              <a href="#" class="logo">
                <b-img src="@/assets/images/logo-transparent.png" class="site-logo"></b-img>
              </a>
              <nav class="nav-menu-wrapper">
                  <div class="nav-menu">
                    <b-list-group horizontal>
                      <b-list-group-item @click="jumpTo('/')">Home</b-list-group-item>
                      <b-list-group-item @click="jumpTo('/day-care-service')">Day Care Services</b-list-group-item>
                      <b-list-group-item @click="jumpTo('/home-care-service')">Home Care Services</b-list-group-item>
                      <b-list-group-item @click="jumpTo('/about-us')">About Us</b-list-group-item>
                      <b-list-group-item @click="jumpTo('/careers')">Careers</b-list-group-item>
                      <b-list-group-item @click="jumpTo('/contactus')">Contact</b-list-group-item>
                    </b-list-group>
                  </div>
              </nav>
              <div class="info d-flex flex-column">
                <div class="email info-detail d-flex flex-row align-items-center justify-content-start">
                  <b-icon icon="envelope-fill" scale="1.2"></b-icon>
                  <div class="text" id="email" @click="sendEmail">Email: {{email}}</div>
                  <b-popover target="email" triggers="hover" placement="top">
                    <template #title></template>
                    Copy to clipboard
                  </b-popover>
                </div>
                <div class="phone info-detail d-flex flex-row align-items-center justify-content-start">
                  <b-icon icon="telephone-fill" scale="1.2"></b-icon>
                  <div class="text" @click="call">Phone: {{phone}}</div>
                </div>
                <div class="address info-detail">
                  <p>
                    7327 137 St #411,<br>
                    Surrey, BC<br>
                    V3W 1A4
                  </p>
                  <p>
                    11 Ivy Bush Ave #202,<br>
                    Scarborough, ON<br>
                    M1V 2W7
                  </p>
                </div>
              </div>
              <!-- <div class="tag" @click="jumpTo('https:////bccare.ca/', true)">
                <b-img src="@/assets/images/white-bc-care.png"></b-img>
              </div> -->
              <div class="text-copyright">
                Copyright © Lady W Senior Care Service Ltd.
                <br>
              </div>
            </div>
        </section>
    </footer>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      email: 'contact@ladywseniorcare.ca',
      phone: '(778) 952-8268'
    };
  },
  methods: {
    jumpTo(href, out) {
      if (!out) {
        this.$router.replace({
          path: href
        }).catch(()=>{})
      } else {
        location.href = href;
      }
    },
    sendEmail(e) {
      const email = this.email;
      navigator.clipboard.writeText(email).then(function() {
          // console.log("Text successfully copied to clipboard!");
      }).catch(function(err) {
          // console.error("Unable to copy text to clipboard", err);
      });
      const mailtoLink = `mailto:${email}`;
      location.href = mailtoLink;
    },
    call() {
      const phoneNumber = this.phone;
      const telLink = `tel:${phoneNumber}`;
      window.location.href = telLink;
    }
  }
};
</script>
<style lang="scss" scoped>
.ic-footer {
  background-position: 50%;
  background-size: cover;
  flex-shrink: 0;
  margin-top: auto;
  position: relative;
  width: 100%;
  color: $w-color;
  font-size: 1.8rem;
  font-weight: 400;
  .wrapper {
    position: relative;
    min-height: 50svh;
    background-image: url('../assets/images/old-couple-smiling.jpg');
    background-size: cover;
    background-position: center center;
    padding: 12rem 3rem;
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    &::before{
      background-image: linear-gradient(rgba(0, 0, 0, 0.73), rgba(0, 0, 0, 0.73));
      position: absolute;
      content: "";
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      pointer-events: none;
      z-index: 1;
    }
  }
}
.content {
  row-gap: 4.5rem;
  width: 1440px;
  max-width: 100%;
  .logo {
    z-index: 4;
    img.site-logo {
      height: 15rem;
      display: block;
      width: auto;
    }
  }
  .info {
    z-index: 4;
    row-gap: 2.1rem;
    .info-detail {
      column-gap: 1.2rem;
    }
    .address {
      text-align: center;
      margin-top: 2.4rem;
      p:nth-of-type(2) {
        margin-top: 1.8rem;
      }
    }
  }
  .tag {
    z-index: 4;
    width: auto;
    height: 8rem;
    display: inline-block;
    img {
      object-fit: contain;
      height: 100%;
    }
  }
  .text-copyright {
    z-index: 4;
    font-size: 12px;
    line-height: 1.3;
    text-align: center;
  }
}
.nav-menu-wrapper {
  z-index: 4;
  .list-group {
    .list-group-item {
      border: 0;
      background: transparent;
      cursor: pointer;
    }
  }
}
@media (max-width: 767px) {
  .list-group {
    flex-direction: column;
    align-items: center;
    .list-group-item {
      padding: 0;
    }
  }
}
@media((max-width: 1280px)) {
    .content {
      width: 1100px;
    }
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue